<template>
  <div id="index">
    <div class="navbar">
      <a class="title" v-if="screenSize >= 769" @click="index">Bodor+ 3.0</a>
      <div class="navcontent">
        <div
          v-for="(item, index) in menuItems"
          :key="item.id"
          class="navitems"
          :class="{ active: isActive(item) }"
          @click="togglePage(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <div @click="back" class="back">
        {{ $t("visitor.back") }}
      </div>
    </div>
    <router-view></router-view>
    <PageFooter />
  </div>
</template>

<script setup>
import { ref, h, onMounted, onUnmounted, watch } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import PageFooter from "@/components/PageFooter.vue";
import { throttle } from "@/utils/util.js";
import { Modal } from "ant-design-vue";

const { t } = useI18n();

let router = useRouter();

const assetsUrl = require("@/assets/img/software/appicon.png");
const assetsUrl2 = require("@/assets/img/software/appicon2.png");

const menuItems = ref([
  { id: "software", name: t("index.software") },
  { id: "knowledge", name: t("index.knowledge") },
  { id: "download", name: t("index.downloadCenter") },
]);
const activeItem = ref(null);

let backRouter = ref(localStorage.getItem("router"));

// 响应式数据，用于存储屏幕大小分类
const screenSize = ref();

// 监听窗口大小变化的函数
function handleResize() {
  const width = window.innerWidth;
  /*   if (width < 600) {
    screenSize.value = "small";
  } else if (width < 1200) {
    screenSize.value = "medium";
  } else {
    screenSize.value = "large";
  } */
  screenSize.value = width;
}

// 使用throttle封装handleResize，并保存引用
const throttledResize = throttle(handleResize, 500);

watch(backRouter, (value) => {
  if (backRouter.value) {
    menuItems.value.forEach((items) => {
      if (items.id == backRouter.value) {
        togglePage(items);
        return;
      }
    });
  } else {
    togglePage(menuItems.value[0]);
  }
});

let lang = localStorage.getItem("lang");
localStorage.setItem("lang", lang);

function isActive(item) {
  return item === activeItem.value;
}
function togglePage(item) {
  if (screenSize.value >= 769) {
    activeItem.value = item;
    router.push(`/visitor/${item.id}`);
  } else {
    Modal.info({
      title: t("home.phone"),
      content: h("div", { class: "infoContainer" }, [
        h("p", t("home.appin2")),
        h("img", {
          src: localStorage.getItem("lang") == "zh" ? assetsUrl : assetsUrl2,
          width: "150",
          height: "150",
        }),
      ]),
      okText: t("home.appok"),
      maskClosable: true,
      onOk() {
        Modal.destroyAll();
      },
    });
  }
}

const index = () => {
  location.reload();
  togglePage(menuItems.value[0]);
};
const back = () => {
  let lang = localStorage.getItem("lang");
  localStorage.clear();
  localStorage.setItem("lang", lang);
  router.push("/");
};
const usercenter = () => {
  router.push("/usercenter");
};
onMounted(() => {
  backRouter.value = localStorage.getItem("router");

  window.addEventListener("resize", throttledResize);
  handleResize(); // 初始时立即检查
});

onUnmounted(() => {
  window.removeEventListener("resize", throttledResize);
});
</script>

<style scoped>
#index {
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: relative;
  display: flex;
}
.usermenu {
  width: 120px;
  height: 0px;
  overflow: hidden;
  align-items: center;
  position: absolute;
  box-shadow: 0 10px 10px -2px #0000001f;
  transition: all 0.5s;
  top: 60px;
  right: 123px;
  z-index: 999;
  transform: translate(50%, 0%);
}
.usermenuitems {
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: black;
  cursor: pointer;
}
.usermenuitems:hover {
  background-color: #eeeeee;
}
.title {
  font-weight: bold;
  font-size: 24px;
  cursor: pointer;
  color: white;
  position: absolute;
}
.navbar {
  width: 100%;
  box-sizing: border-box;
  height: 60px;
  border: solid #ddd;
  border-width: 0 0 1px;
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  background: rgba(29, 29, 31, 0.7);
  position: fixed;
  z-index: 999;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 100px;
  color: white;
  border-radius: 0px;
}
.navcontent {
  display: flex;
  align-items: center;
  height: 100%;
  margin: 0px auto;
}
.navitems {
  height: 100%;
  padding: 0 15px;
  line-height: 60px;
  text-align: center;
  cursor: pointer;
}
.active {
  border-bottom: 3px solid rgb(255, 70, 16);
}
.headimg {
  width: 45px;
  height: 45px;
  border-radius: 100%;
  cursor: pointer;
  position: absolute;
  right: 100px;
}
.headimg:hover ~ .usermenu {
  height: 100px;
}
.usermenu:hover {
  height: 100px;
}
.back {
  cursor: pointer;
}
@media (max-width: 767px) {
  .navbar {
    padding: 0px 20px;
  }
}
</style>
